<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GGXrYT/tc-custom/9781605096704.jpg?1736599480280" alt="This image is the cover for the book Art of Convening"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Art of Convening
      </h1>
      <p class="bookDescription body article font2">
        <p>‚ÄúMeetings are a waste of time‚Äù is a sentiment many of us share, which is tragic because meetings bring us together as human beings. To achieve the kind of meaning or breakthrough results most of us really yearn for when we gather, the key quality needed is authentic engagement: a genuine expression of what is true for us, and an attentive listening to what is true for others. Why it so often eludes us can be a matter of habit, distrust, lack of attention, or fear.<br/><br/><br/>As cofounders of Heartland Inc., Craig and Patricia Neal have led over 170 of their acclaimed Thought Leader Gatherings with leaders from over 800 diverse organizations. Their new book shares for the first time the unique and powerful Art of Convening model‚Äîdeveloped in these gatherings and refined over six years of intensive trainings‚Äîwhich brings authentic engagement and meaning to any group that comes together for any purpose.<br/><br/><br/>Convening goes beyond facilitating. Convening creates an environment in which all voices are heard, profound exchanges take place, and transformative action results. The heart of this book is the Convening Wheel‚Äîa series of nine steps, or aspects, that bring the practices and principles needed for authentic engagement together as a whole. The book provides exercises, stories, and questions to help you master both the inner and outer dimensions of this work‚Äîbecause in convening, the state of the convener is equally as important as the physical preparations.<br/><br/><br/>Convening works in any setting and can be adapted to virtually any group process. With this book you have all the tools you need to develop this essential life and leadership skill, one that will lead to improved outcomes in your organization, community, family, and relationships.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Craig Neal, Patricia Neal, Cynthia Wold, Richard J. Leider, Richard J Leidere
      </h2>
      
      <p class="authorDescription body article">Craig Neal is a passionate change leader, publishing executive, organizational executive, and guide. From the 70s to the 90s Craig held executive positions with Garden Way, Inc, Rodale Publishing, and as Associate Publisher, launched Harrowsmith and Eating Well magazines. He’s the founder and former publisher of the Utne Reader. Patricia Neal is co-founder and President of Heartland Inc. Patricia’s focus is inspiring Heartland’s growth through program development and execution. Under her guidance, Heartland’s signature programs have grown to include: Thought Leader Gatherings, The Art of Convening Trainings, VisionHolder Interview Series, When Women Lead: The Inner Voice of Women’s Leadership Retreat, Men’s Wilderness Journey Retreat, and consulting and coaching programs. All Heartland programs are dedicated to community leaders committed to taking their visions into action.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Berrett-Koehler Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?47a56b20